import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpGeneralService } from '../../shared';
import { CONFIG } from '../../shared/config';
let qrCodeUrl = CONFIG.baseUrls.GenerateQrCode;
export interface QrCodeParams {
  branchNameArQ: string;
  vatRegNo: string;
  receiptSerial: string;
  transDate: string;
  qrTotalPayedValue: string;
  totalPatVat: string;
}
@Injectable({
  providedIn: 'root'
})
export class GenerateQrCodeService {
  constructor(private httpGeneralService: HttpGeneralService) {

  }
  generateQrShape(qrCodeParms: QrCodeParams) {
    return this.httpGeneralService.post(qrCodeParms, `${qrCodeUrl}/generateQrCode`);
  }

  generateQrShape2(qrCodeParms: QrCodeParams) :Observable<any> {
    return this.httpGeneralService.post(qrCodeParms, `${qrCodeUrl}/generateQrCode`);
  }
}
